import { render, staticRenderFns } from "./CompanyDocumentPreview.vue?vue&type=template&id=6ed729fc&"
import script from "./CompanyDocumentPreview.vue?vue&type=script&lang=js&"
export * from "./CompanyDocumentPreview.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDocumentPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CompanyDocumentPreview.vue"
export default component.exports